import React from 'react';
import { AccountProfile } from './components';
import { AccountDetails } from '../../components/organisms/forms/AccountDetails/index';
import { MY_ID } from '../../helpers/user/authorization';
import { ContainerTwoThirds } from 'components/layouts/ContainerTwoThirds';
import { AvatarChoiceBlock } from 'components/molecules/Blocks/AvatarChoiceBlock';
import { ProfileInfo } from '../../types/user/user.def';

interface AccountViewProps {
  user: ProfileInfo;
}

const AccountView = ({ user }: AccountViewProps) => {
  const isMyProfil = user.id === MY_ID;

  return (
    <>
      <div>
        <ContainerTwoThirds
          variant="reverse"
          col1={
            <>
              <AccountProfile user={user} />
              {isMyProfil && (
                <AvatarChoiceBlock userid={user.id} visibleTitle={true} />
              )}
            </>
          }
          col2={
            <AccountDetails
              user={user}
              editablePassword={true}
              visibleTitle={true}
            />
          }
        />
      </div>
    </>
  );
};

export default AccountView;
